import { post, get, form } from '../axios'

export function cmc_admin_coldStart_config_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/weeks`,
    map,
    option
  ).then(response => response)
}

// 新品冷启动配置分页列表
export function cmc_admin_coldStart_config_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/list`,
    map,
    option
  ).then(response => response)
}

// 新增冷启动扶持配置
export function cmc_admin_coldStart_config_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/save`,
    map,
    option
  ).then(response => response)
}

// 编辑冷启动扶持配置
export function cmc_admin_coldStart_config_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/update/${map.configId}`,
    map,
    option
  ).then(response => response)
}

// 删除冷启动扶持配置
export function cmc_admin_coldStart_config_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/delete`,
    map,
    option
  ).then(response => response)
}

// 切换冷启动扶持配置状态
export function cmc_admin_coldStart_config_enable_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/toggleStatus`,
    map,
    option
  ).then(response => response)
}

// 批量导入冷启动扶持配置
export function cmc_admin_coldStart_config_batchImport_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/import/confirm`,
    map,
    option
  ).then(response => response)
}

// 预览批量导入冷启动扶持配置
export function cmc_admin_coldStart_config_batchImport_preview_post(
  map,
  option
) {
  return form(
    `${process.env.VUE_APP_ADMIN}/col/newSupport/import/preview`,
    map,
    option
  ).then(response => response)
}

// // 查询站点全局配置列表
// export function cmc_admin_coldStart_siteConfig_list_get(map, option) {
//   return get(
//     `${process.env.VUE_APP_ADMIN}/cmc-admin/coldStart/siteConfig/list`,
//     map,
//     option
//   ).then(response => response)
// }

// // 保存站点全局配置
// export function cmc_admin_coldStart_siteConfig_save_post(map, option) {
//   return post(
//     `${process.env.VUE_APP_ADMIN}/cmc-admin/coldStart/siteConfig/save`,
//     map,
//     option
//   ).then(response => response)
// }
